module.exports = __webpack_public_path__ + "static/media/banner2.c688e16c.jpg";